module.exports = __webpack_public_path__ + "static/img/Bachelor_010687.664ab19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010687.jpg
// module id = 213
// module chunks = 0